// extracted by mini-css-extract-plugin
export default {"searchTopic":"SearchTopic_searchTopic__bGw2z"};